import React from "react";
import { Props } from "./types";

function ReportIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="-0.5 -0.5 23.04 30.002">
      <g transform="translate(-0.002 0.002)">
        <path
          d="M-3644.538,17886h-17.4a2.321,2.321,0,0,1-2.316-2.32v-24.361a2.321,2.321,0,0,1,2.316-2.32h9.5v5.8a3.266,3.266,0,0,0,3.263,3.264h6.962v17.619A2.323,2.323,0,0,1-3644.538,17886Zm-4.281-15.5a.062.062,0,0,1,.04.014c.05.049-.027.166-.072.215l-6.522,7.344a.625.625,0,0,0-.063.736l2.5,4.008a.326.326,0,0,0,.295.18.31.31,0,0,0,.289-.184l5.849-14.135a.321.321,0,0,0-.021-.312.329.329,0,0,0-.273-.15.333.333,0,0,0-.14.031l-14.135,6.164a.319.319,0,0,0-.184.295.324.324,0,0,0,.193.293l3.824,2.158a.612.612,0,0,0,.307.082.609.609,0,0,0,.4-.148l7.541-6.5A.332.332,0,0,1-3648.82,17870.5Zm6.131-7.316h-5.683a1.188,1.188,0,0,1-1.185-1.189v-4.525a.465.465,0,0,1,.462-.467,1.977,1.977,0,0,1,1.284.467l4.767,3.973a1.827,1.827,0,0,1,.669,1.428A.311.311,0,0,1-3642.689,17863.18Z"
          transform="translate(3664.26 -17857)"
        />
      </g>
    </svg>
  );
}

export { ReportIcon };
